import {Carrier} from './carrier';

export class User {
  Id: string;
  Username: string;
  Password: string;
  Name: string;
  Active: boolean;
  Type: string;
  CompanyId: string;
  Carriers: Carrier[];
  Routes: Carrier[] = [];
  DefaultDepartmentId: string;
}
